<template>
  <div v-if="!feedbkForm" style="height: 100dvh">
    <div
      class="
        page-head-mob
        p-3
        d-flex
        justify-content-between
        align-items-center
      "
    >
      <div>
        <img
          @click="goBackschedule"
          class="mr-3 mb-1 pointer"
          src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
          alt=""
        />Candidate Details
      </div>
      <div class="d-flex justify-content-between">
        <div class="pr-3" v-if="$route.query.status != 'feedbacktab'">
          <img
            @click="navigateToLink()"
            src="../../assets/panelLog/mob-design/join_group_mob.svg"
            alt=""
          />
        </div>
        <div>
          <img
            @click="exportresume"
            src="../../assets/panelLog/mob-design/download_resume_mob.svg"
          />
        </div>
      </div>
    </div>
    <!-- <mobHeader /> -->
    <div class="mobile-body-cd">
      <div
        class="mob-pan-body-cd py-2 px-1"
        :class="{
          'mob-pan-body-cd': candidate.feedback == false,
          'mob-pan-body-cd-fp': candidate.feedback,
        }"
      >
        <div class="pt-2 px-3">
          <div class="cd-sm-headings mb-1">Name</div>
          <div class="cd-sm-txts text-truncate mb-2">
            {{ candidate.candidate.name }}
          </div>
          <div class="d-flex justify-content-between">
            <div>
              <div class="cd-sm-headings mb-1">Email</div>
              <div class="cd-sm-txts text-truncate mb-2">
                {{ candidate.candidate.email }}
              </div>
            </div>
            <div class="pr-2">
              <div class="cd-sm-headings mb-1">Contact No.</div>
              <div class="cd-sm-txts text-truncate mb-2">
                {{ candidate.candidate.phoneNumber }}
              </div>
            </div>
          </div>
          <div class="cd-sm-headings mb-1">Skills</div>
          <div class="cd-sm-txts mb-2">{{ arrayToString }}</div>
          <div class="d-flex justify-content-between">
            <div>
              <div class="cd-sm-headings mb-1">Job Name</div>
              <div class="cd-sm-txts text-truncate mb-2">
                {{ candidate.jobName }}
              </div>
            </div>
            <div class="pr-4">
              <div class="cd-sm-headings mb-1">Rounds</div>
              <div class="cd-sm-txts text-truncate mb-2">
                {{ candidate.interviewRound.roundOfrounds }}
              </div>
            </div>
          </div>
          <!-- {{ candidate }} -->
          <div class="cd-sm-headings mb-1">Interview Timings</div>
          <div class="cd-sm-txts mb-2">{{ candidate.startTimeFormatted }}</div>
        </div>
        <hr />
        <div
          class="cd-vf-box"
          v-if="feedbackHistory && feedbackHistory.length != 0"
        >
          <div class="p-2 px-3">
            <div class="d-flex align-items-center">
              <div class="mr-2">
                <img src="../../assets/panelLog/mob-design/v-fd-his.svg" />
              </div>
              <div class="vf-box-head">Feedback History</div>
            </div>
            <div>
              <div
                v-for="(i, index) in feedbackHistory"
                :key="index + 'feedback'"
                class="vc-card-container-mob mt-3"
              >
                <div
                  @click.stop="toggleCollapse(index)"
                  class="padding-6-19"
                  :class="[
                    index === activeIndex
                      ? 'vc-open-card-mob'
                      : 'vc-close-card-mob',
                    'pointer',
                  ]"
                >
                  <div class="d-flex justify-content-between w-100">
                    <div>
                      <div class="vc-black-txt-mob">Round {{ index + 1 }}</div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="vc-darkgrey-txt-mob mr-2">
                        {{ formatDate(i.createdAt) }}
                      </div>

                      <img
                        v-if="!collapsedIndexes[index]"
                        class="pointer vf-dpd-arr-mob"
                        src="../../assets/panelLog/down_arrow.svg"
                        alt=""
                      />
                      <img
                        v-else
                        class="pointer vf-dpd-arr-mob"
                        src="../../assets/panelLog/dpd_open.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <b-collapse v-model="collapsedIndexes[index]">
                  <div class="ml-1 px-3 py-2">
                    <div class="d-flex justify-content-between">
                      <div>
                        <div class="cd-sm-headings mb-1">Panel Name</div>
                        <div class="cd-sm-txts mb-2">
                          {{ i.panelName }}
                        </div>
                      </div>
                      <div class="mr-4 pr-2">
                        <div class="cd-sm-headings mb-1">Action</div>
                        <div class="cd-sm-txts mb-2">
                          {{
                            showRecOptions && i.feedbackText
                              ? i.feedbackText
                              : i.recommendation == "R"
                              ? "Rejected"
                              : i.recommendation == "H"
                              ? "On-Hold"
                              : i.recommendation == "NI"
                              ? "Not Interested"
                              : i.recommendation == "DNA"
                              ? "No Show"
                              : (i.recommendation == "S" ||
                                  i.recommendation == "FS" ||
                                  i.recommendation == "F") &&
                                i.awaitingForApproval == null
                              ? "Selected"
                              : i.awaitingForApproval == "0" &&
                                i.recommendation == "F"
                              ? "Approval pending from Ops Head"
                              : ""
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="cd-sm-headings mb-1">Remarks</div>
                    <div class="cd-sm-txts border-bottom-line mb-2 pb-1">
                      {{ i.recruiterRemarks }}
                    </div>
                    <div
                      v-if="i.panelFeedbackForm != null"
                      class="d-flex justify-content-end w-100 pointer"
                      @click="downloadFeedback(i.panelFeedbackForm)"
                    >
                      <div class="d-flex pointer">
                        <img
                          class="mr-1 fdbk-link-mob"
                          src="../../assets/panelLog/download_fdfm.svg"
                        />
                        <div class="fdbk-txt-mob">Feedback Form</div>
                      </div>
                    </div>

                    <div
                      v-else-if="i.interviewRoundObj.id != 'F'"
                      @click.stop="assignfilledvalues(i)"
                      class="d-flex justify-content-end w-100 pointer"
                    >
                      <div class="d-flex pointer">
                        <img
                          class="mr-1 fdbk-link-mob"
                          src="../../assets/panelLog/preview_eye.svg"
                        />
                        <div class="fdbk-txt-mob">Feedback Form</div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div class="cd-vf-box mt-3" v-if="panelJdDetails">
          <div>
            <div class="d-flex align-items-center p-3">
              <div>
                <img
                  class="mr-2"
                  src="../../assets/panelLog/mob-design/jddetails-mob.svg"
                />
              </div>
              <div class="vf-box-head">Job Details</div>
            </div>
            <div v-if="jdDetailsType == 1">
              <div
                class="panlog-jobdeatils py-2 px-3 mb-2"
                v-for="(field, index) in basicArray"
                :key="field.key + index"
              >
                <div class="panlog-right-deatils-heading">
                  {{ field.label }}
                </div>
                <div class="panlog-right-detail-subheads mt-7px">
                  <div v-if="checkFieldKeys(field)">-</div>
                  <div
                    style="word-break: keep-all"
                    v-else-if="Object.keys(panelJdDetails).length > 0"
                  >
                    <template v-if="isHtmlContent(field)">
                      <div v-html="checkValuesOfKey(field)"></div>
                    </template>
                    <template v-else>
                      {{ checkValuesOfKey(field) }}
                    </template>
                  </div>
                  <div
                    v-if="
                      !checkFieldKeys(field) &&
                      field.controlType == 'upload_file'
                    "
                    class="pointer"
                  >
                    <img
                      @click="downloadFile(field)"
                      class="ml-2"
                      src="../../assets/talentpool/tp_download_vc.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="jdDetailsType == 2" class="ml-3">
              <template v-if="allDetailDropDowns === 'openBasic'">
                <div class="vc-card-container-mob mr-3">
                  <div
                    class="
                      vc-open-card-mob
                      d-flex
                      align-items-center
                      justify-content-between
                      padding-6-19
                      pointer
                    "
                    @click="openDropDownJDModal('close')"
                  >
                    <div class="vc-black-txt-mob">Basic Details</div>
                    <div>
                      <img
                        class="vf-dpd-arr-mob mr-1"
                        src="../../assets/panelLog/up_arrow.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="panlog-jobdeatils py-2 px-3 mb-2"
                    v-for="(field, index) in basicArray"
                    :key="field.key + index"
                  >
                    <div class="panlog-right-deatils-heading">
                      {{ field.label }}
                    </div>
                    <div class="panlog-right-detail-subheads mt-7px">
                      <div v-if="checkFieldKeys(field)">-</div>
                      <div
                        style="word-break: keep-all"
                        v-else-if="Object.keys(panelJdDetails).length > 0"
                      >
                        <template v-if="isHtmlContent(field)">
                          <div v-html="checkValuesOfKey(field)"></div>
                        </template>
                        <template v-else>
                          {{ checkValuesOfKey(field) }}
                        </template>
                      </div>
                      <div
                        v-if="
                          !checkFieldKeys(field) &&
                          field.controlType == 'upload_file'
                        "
                        class="pointer"
                      >
                        <img
                          @click="downloadFile(field)"
                          class="ml-2"
                          src="../../assets/talentpool/tp_download_vc.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" v-if="advanceArray.length">
                    <div
                      class="d-flex align-items-center pointer ml-2"
                      @click="advance = !advance"
                    >
                      <img
                        v-if="!advance"
                        class="advance-img-mob"
                        src="../../assets/panelLog/advance.svg"
                        alt=""
                      />
                      <img
                        v-else
                        class="advance-img-mob"
                        src="../../assets/panelLog/advance-down.svg"
                        alt=""
                      />

                      <span class="advance-txt-mob ml-2 mr-2 pointer"
                        >Advanced</span
                      >
                      <hr />
                    </div>
                  </div>
                  <div v-if="advance">
                    <div
                      class="panlog-jobdeatils py-2 px-3 mb-2"
                      v-for="(field, index) in advanceArray"
                      :key="field.key + index"
                    >
                      <div class="panlog-right-deatils-heading">
                        {{ field.label }}
                      </div>
                      <div class="panlog-right-detail-subheads mt-7px">
                        <div v-if="checkFieldKeys(field)">-</div>
                        <div
                          style="word-break: keep-all"
                          v-else-if="Object.keys(panelJdDetails).length > 0"
                        >
                          <template v-if="isHtmlContent(field)">
                            <div v-html="checkValuesOfKey(field)"></div>
                          </template>
                          <template v-else>
                            {{ checkValuesOfKey(field) }}
                          </template>
                        </div>
                        <div
                          v-if="
                            !checkFieldKeys(field) &&
                            field.controlType == 'upload_file'
                          "
                          class="pointer"
                        >
                          <img
                            @click="downloadFile(field)"
                            class="ml-2"
                            src="../../assets/talentpool/tp_download_vc.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <div
                  class="
                    basic-close-mob
                    mr-3
                    d-flex
                    align-items-center
                    justify-content-between
                    pointer
                  "
                  @click="openDropDownJDModal('openBasic')"
                >
                  <div class="vc-black-txt-mob">Basic Details</div>
                  <div>
                    <img
                      class="vf-dpd-arr-mob mr-1"
                      src="../../assets/panelLog/down_arrow.svg"
                      alt=""
                    />
                  </div>
                </div>
              </template>
              <template v-if="allDetailDropDowns === 'openIP'">
                <div class="mt-3 vc-card-container-mob mr-3">
                  <div
                    class="
                      vc-open-card-mob
                      d-flex
                      align-items-center
                      justify-content-between
                      padding-6-19
                      pointer
                    "
                    @click="openDropDownJDModal('close')"
                  >
                    <div class="vc-black-txt-mob">Interview Process</div>
                    <div>
                      <img
                        class="vf-dpd-arr-mob mr-1"
                        src="../../assets/panelLog/up_arrow.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="panlog-ip-container mt-2">
                    <div class="intpro-head-mob">Interview Rounds</div>
                    <div
                      class="mt-4 d-flex w-100"
                      v-for="(i, index) in panelJdDetails.interviewProcess
                        .process"
                      :key="index"
                    >
                      <div class="position-relative">
                        <div class="panlog-ip-side-circle"></div>
                        <div
                          v-if="
                            index <
                            panelJdDetails.interviewProcess.process.length - 1
                          "
                          class="panlog-ip-side-line"
                        ></div>
                      </div>
                      <div class="d-flex justify-content-between ml-3 w-100">
                        <div>
                          <div class="panlog-ip-main-head">
                            Round {{ index + 1 }} -
                            {{
                              i.type === "f2f" ? "Face to face" : "Assessment"
                            }}
                          </div>
                          <div class="panlog-ip-sub-head-mob">{{ i.name }}</div>
                        </div>
                        <div>
                          <img
                            v-if="i.type === 'assesment'"
                            src="../../assets/panelLog/ipasmntround.svg"
                            alt=""
                          />
                          <img
                            v-else-if="i.type === 'f2f'"
                            src="../../assets/panelLog/f2fimg.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <div
                  class="
                    basic-close-mob
                    mr-3
                    d-flex
                    align-items-center
                    justify-content-between
                    mt-3
                    pointer
                  "
                  @click="openDropDownJDModal('openIP')"
                >
                  <div class="vc-black-txt-mob">Interview Process Details</div>
                  <div>
                    <img
                      class="vf-dpd-arr-mob mr-1"
                      src="../../assets/panelLog/down_arrow.svg"
                      alt=""
                    />
                  </div>
                </div>
              </template>

              <template v-if="allDetailDropDowns === 'openRecPan'">
                <div class="mt-3 vc-card-container-mob mr-3">
                  <div
                    class="
                      vc-open-card-mob
                      d-flex
                      align-items-center
                      justify-content-between
                      padding-6-19
                      pointer
                    "
                    @click="openDropDownJDModal('close')"
                  >
                    <div class="vc-black-txt-mob">Allocate</div>
                    <div>
                      <img
                        class="vf-dpd-arr-mob mr-1"
                        src="../../assets/panelLog/up_arrow.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="p-2 overflow-auto">
                    <div class="createjobs-viewjd-recbox">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div class="allocate-head-txt-mob">Recruiters</div>
                      </div>
                      <div class="mt-2">
                        <div class="d-flex align-items-center flex-wrap gap-15">
                          <div
                            class="allocate-boxes text-break allocate-boxes-txt"
                            v-for="(rec, index) in panelJdDetails.assignedTo"
                            :key="index"
                          >
                            {{ rec.username }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="createjobs-viewjd-recbox">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div class="allocate-head-txt-mob">Panelists</div>
                      </div>

                      <div
                        class="hint-txt-allocate-mob mt-2"
                        v-if="
                          panelJdDetails.showAllPanelist == true &&
                          panelJdDetails.assignedPanelist.length == 0
                        "
                      >
                        All panelists are allocated for this JD
                      </div>
                      <!-- use below line if there are no panel list same goes to recruiters and vendors -->
                      <div
                        class="hint-txt-allocate-mob mt-2"
                        v-else-if="
                          panelJdDetails.showAllPanelist == false &&
                          panelJdDetails.assignedPanelist.length == 0
                        "
                      >
                        No panelists are allocated
                      </div>
                      <div
                        class="d-flex align-items-center flex-wrap gap-15 mt-2"
                        v-else-if="
                          panelJdDetails.showAllPanelist == false &&
                          panelJdDetails.assignedPanelist.length != 0
                        "
                      >
                        <div
                          class="allocate-boxes allocate-boxes-txt"
                          v-for="(
                            pan, index
                          ) in panelJdDetails.assignedPanelist"
                          :key="index"
                        >
                          {{ pan.username }}
                        </div>
                      </div>
                    </div>

                    <div class="createjobs-viewjd-recbox">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div class="allocate-head-txt-mob">Vendors</div>
                      </div>
                      <div
                        class="hint-txt-allocate-mob mt-2"
                        v-if="panelJdDetails.vendor.length == 0"
                      >
                        No vendors are allocated
                      </div>
                      <div
                        class="d-flex align-items-center flex-wrap gap-15 mt-2"
                        v-else
                      >
                        <div
                          class="allocate-boxes allocate-boxes-txt"
                          v-for="(vendor, index) in panelJdDetails.vendor"
                          :key="index"
                        >
                          {{ vendor.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <div
                  class="
                    basic-close-mob
                    mr-3
                    d-flex
                    align-items-center
                    justify-content-between
                    mt-3
                    pointer
                  "
                  @click="openDropDownJDModal('openRecPan')"
                >
                  <div class="vc-black-txt-mob">Allocate</div>
                  <div>
                    <img
                      class="vf-dpd-arr-mob mr-1"
                      src="../../assets/panelLog/down_arrow.svg"
                      alt=""
                    />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="candidate.feedback == false && $route.query.status != false"
        class="panlg-footer-mob"
      >
        <div class="addpan mr-3">
          <b-button
            class="btn-txt-mob btn-mob-size-form"
            @click="getfeedbackforms()"
          >
            Give Feedback
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      id="photo"
      size="lg"
      centered
      hide-footer
      hide-header
      :no-close-on-backdrop="true"
      style="width: 20%"
      @hidden="closePhoto"
    >
      <b-row style="margin-bottom: 1.5em">
        <b-col>
          <label class="caution-txt">IMAGE OF CANDIDATE TAKING INTERVIEW</label>
        </b-col>
        <b-col>
          <div
            @click="closePhoto"
            class="xMarkCancel"
            :style="isLaptop ? '' : 'right:16px;top:6px;'"
          >
            <img src="../../assets/cross-round.svg" alt="" />
          </div>
        </b-col>
      </b-row>
      <div style="height: 30%; width: 100%">
        <img
          :src="candidateCapture.candidateImage"
          class="h-100 w-100"
          alt=""
        />
      </div>
    </b-modal>

    <ViewFeedback :context="this" />
    <JobDetails :panelJdDetails="panelJdDetails" />
    <AllJobDetails
      :panelJdDetails="panelJdDetails"
      :allDetailDropDowns="allDetailDropDowns"
    />
    <LastRoundFeedback
      :viewfeedback="viewfeedback"
      :feedback="feedback"
      :interviewCandidate="interviewCandidate"
      :interviewResponse="interviewResponse"
      @giveLastFdbck="getAllPanelCandidate"
      :showGiveFeebackButton="showGiveFeebackButton"
    />
    <GiveFeedback
      :viewfeedback="viewfeedback"
      :feedback="feedback"
      :interviewResponse="interviewResponse"
      :interviewCandidate="interviewCandidate"
      :feedbackform="feedbackform"
      :uploadcandheight="uploadcandheight"
      :allpaneldata="allpaneldata"
      :showfeedbackSpinner="showfeedbackSpinner"
      :showGiveFeebackButton="showGiveFeebackButton"
    />
  </div>
  <div v-else>
    <GiveFeedbackForm
      :selectedRound="passData"
      :basicCandInfo="candidateDetails"
      :allData="allData"
      :viewfeedback="viewfeedback"
      :feedback="feedback"
      :panelName="panelName"
      :evalDate="evalDate"
      :interviewResponse="interviewResponse"
      :interviewCandidate="interviewCandidate"
      :feedbackform="feedbackform"
      :uploadcandheight="uploadcandheight"
      :allpaneldata="allpaneldata"
      :showfeedbackSpinner="showfeedbackSpinner"
      :showGiveFeebackButton="showGiveFeebackButton"
      :candidate="candidate"
      @goBack="openDivs"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mobilePanelMixins from "../../views/panelLogin/mobilePanelMixins.js";
import { downloadFeedback } from "../../utils/download.js";

import ViewFeedback from "../../controllers/JD/modals/ViewFeedback.vue";
import AllJobDetails from "../../controllers/panelLogin/modals/AllJobDetails";
import JobDetails from "../../controllers/panelLogin/modals/JobDetails";
import GiveFeedback from "../../controllers/panelLogin/modals/GiveFeedback.vue";
import LastRoundFeedback from "../../controllers/panelLogin/modals/LastRoundFeedback";
import GiveFeedbackForm from "../../views/panelLogin/GiveFeedbackForm";
import {
  exportResume,
  history,
  getPanelJdDetails,
  getallfeedbackforms,
  mob_exportResume,
} from "../../controllers/panelLogin/asynchronous.js";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
import {
  getCustomerFields,
  downloadAnyFile,
} from "../../utils/apiFunctions.js";
// import mobHeader from "../../components/fixedcomponents/MobHeader.vue";
// import { assignfilledvalues } from "../../controllers/panelLogin/helpers.js";
import { getValidations } from "../../controllers/panelLogin/validations";
// import giveFeedbackFormVue from './giveFeedbackForm.vue';
// import GiveFeedbackFormVue from './GiveFeedbackForm.vue';
// import router from '../../router/index.js';

export default {
  name: "CandidateDetails",
  components: {
    ViewFeedback,
    JobDetails,
    AllJobDetails,
    GiveFeedback,
    LastRoundFeedback,
    GiveFeedbackForm,
    // mobHeader,
  },
  data() {
    return {
      customFieldsArray: [],
      basicArray: [],
      advanceArray: [],
      allData: {},
      passData: {},
      candidateDetails: {},
      loopvar: 2,
      feedbkForm: false,
      LoaderStatus: false,
      viewfeedback: false,
      resStatus: 1,
      feedback: {},
      collapsedIndexes: [],
      interviewResponse: {},
      feedbackform: {},
      payload: {},
      interviewCandidate: "",
      candidateCapture: "",
      timer: null,
      searchname: "",
      showGiveFeebackButton: false,
      activeIndex: null,
      advance: false,
      uploadcandheight: "",
      showfeedback: false,
      giveFeedback: false,
      lastRoundfeedback: false,
      particularCand: false,
      scheduleInterviewPage: false,
      panelName: "",
      evalDate: "",
      schedulePage: false,
      feedbackPage: false,
      provideFeedbackPage: false,
      mainPage: false,
      currentPage: 1,
      pageCount: 10,
      feedbackValue: "false",
      statusValue: "createdAt",
      sortOrder: false,
      totalScheduledInterviews: null,
      showLoader: false,
      showfeedbackSpinner: false,
      totalFeedbackProvided: null,
      allpaneldata: [],
      feedbackHistory: [],
      panelJdDetails: {},
      total: null,
      pageEnd: null,
      jdDetailsType: null,
      allDetailDropDowns: "",
      filledfdbckform: {},
      // candidateDetails: {
      //   evalDate: "",

      //   experience: "",

      //   modeOfInterview: "",

      //   name: "",

      //   panel: "",
      // },

      viewScreenshot: "",
    };
  },
  mixins: [mobilePanelMixins],
  computed: {
    ...mapGetters("panelVUEX", {
      candidate: "getParticularCandDetails",
    }),
    ...mapGetters("userVUEX", {
      userInfo: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
    arrayToString() {
      return this.candidate.candidateSkills.join(", ");
    },
    showRecOptions() {
      if (this.thirdPartyData?.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
  },
  validations() {
    return getValidations(this);
  },
  props: {
    isLaptop: Boolean,
  },

  async created() {
    this.getCustomFieldsArray();
    this.showfeedback = true;
    this.getPanelJdDetails();
    await history(this.candidate, this);
    this.showfeedback = false;
    if (this.candidate.interviewRound.roundOfrounds == "F") {
      this.candidate.interviewRound.roundOfrounds = "Final Round";
    }
  },
  methods: {
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.panelJdDetails);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.panelJdDetails);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.panelJdDetails);
    },
    async downloadFile(field) {
      let payload;
      if (field.fieldType != "default") {
        payload = this.candidateData.customFields[field.key];
      } else {
        payload = this.candidateData[field.key];
      }
      const res = await downloadAnyFile(payload);
      if (res.status == 200) {
        const link = res.data.data.downloadLink;
        // implemented bcz once we click on download resume that page shouldn't go blank
        const candidateName = res.data.data.name;

        // Create a dynamic file name based on the candidate's name and email
        const fileName = `${candidateName}_${field.label}.pdf`;

        // Create an anchor element
        const a = document.createElement("a");
        a.href = link;
        a.download = fileName; // Set the dynamically generated file name

        // Trigger a click event on the anchor element
        a.click();
        // this.successModal("Resume downloaded successfully");
      }
    },
    async getCustomFieldsArray() {
      let parentID = 1;
      let response = await getCustomerFields({ parentID });
      if (response.status == 200) {
        this.customFieldsArray = response.data.data.fields;
        this.customFieldsArray.forEach((obj) => {
          if (obj.category === 1 || obj.category === null) {
            this.basicArray.push(obj); // Push objects with category value 1 into category1Array
          } else if (obj.category === 2) {
            this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
          }
        });
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const timeOptions = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };

      const dayOptions = {
        weekday: "short",
      };

      const dateOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
      };

      const timeFormatter = new Intl.DateTimeFormat("en-US", timeOptions);
      const dayFormatter = new Intl.DateTimeFormat("en-US", dayOptions);
      const dateFormatter = new Intl.DateTimeFormat("en-US", dateOptions);

      const formattedTime = timeFormatter.format(date);
      const formattedDay = dayFormatter.format(date);
      const formattedDate = dateFormatter.format(date);

      return `${formattedTime} ${formattedDay}, ${formattedDate}`;
    },
    navigateToLink() {
      if (this.candidate?.interviewRound?.roomId) {
        this.errorModal("Sorry, this interview cannot be taken from mobile");
      } else if (this.candidate?.meetingLink) {
        window.open(this.candidate.meetingLink, "_blank");
      }
    },
    async exportresume() {
      await mob_exportResume(this.candidate, this);
    },
    openDivs(value) {
      this.feedbkForm = value;
    },
    openDropDownJDModal(flag) {
      this.allDetailDropDowns = flag;
    },
    toggleCollapse(index) {
      this.$set(this.collapsedIndexes, index, !this.collapsedIndexes[index]);
      this.activeIndex = index;
    },
    feedbackProvided() {
      this.searchname = "";
      this.payload.feedback = "";
      this.currentPage = 1;
      this.scheduleInterviewPage = true;
      this.feedbackPage = true;
      this.schedulePage = false;
      this.mainPage = false;
      this.particularCand = false;
      this.allpaneldata = [];
      this.getAllPanelCandidate("true");
    },
    schedule() {
      this.searchname = "";
      this.payload.feedback = "";
      this.currentPage = 1;
      this.mainPage = false;
      this.scheduleInterviewPage = true;
      this.schedulePage = true;
      this.feedbackPage = false;
      this.particularCand = false;
      this.allpaneldata = [];
      this.getAllPanelCandidate("false");
    },

    assignfilledvalues(data) {
      this.showGiveFeebackButton = false;
      this.viewfeedback = true;
      this.feedbkForm = true;
      this.passData = data.customFeedback;
      this.candidateDetails = data.customFeedback.basicInfo;
      this.allData = data;
    },
    async exportResume(data) {
      await exportResume(data);
    },
    downloadFeedback(url) {
      downloadFeedback(url);
    },
    downloadImage(url) {
      downloadFeedback(url);
    },

    goBackschedule() {
      if (this.$route.query.status == "feedbacktab") {
        this.$router.push({
          name: "mobpanelDetails",
          query: {
            status: "feedbacktab",
          },
        });
      } else {
        this.$router.push({
          name: "mobpanelDetails",
          query: {
            status: "scheduletab",
          },
        });
      }
    },
    goBack() {
      this.$router.push({
        name: "PanelLogin",
      });
      this.LoaderStatus = true;
      this.searchname = "";
      this.getAllPanelCandidate("true");
      this.getAllPanelCandidate("false");

      this.currentPage = 0;
      this.mainPage = true;
      this.provideFeedbackPage = false;
      this.scheduleInterviewPage = false;
    },

    async getfeedbackforms() {
      this.feedbkForm = true;
      this.showGiveFeebackButton = true;
      this.viewfeedback = false;
      await getallfeedbackforms(this.candidate, this);
    },
    viewImage(data) {
      this.$bvModal.show("photo");
      this.candidateCapture = data;
    },
    closePhoto() {
      this.$bvModal.hide("photo");
    },

    async getPanelJdDetails() {
      await getPanelJdDetails(this.candidate, this);
    },
  },
};
</script>

<style>
.mobile-feedback-shimmer {
  color: #000;
}

.panlg-greentxt {
  color: #038e00;
  font-size: 12px;
  font-weight: 500;
}

.panlg-redtxt {
  color: #d90606;
  font-size: 12px;
  font-weight: 500;
}

.panlg-yellowtxt {
  color: #ffc145;
  font-size: 12px;
  font-weight: 500;
}

.mobile-header {
  background: #fff;
  box-shadow: 0px 4px 20px 0px #000;
  height: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-body-cd {
  height: 91%;
  background: #e9ecef;
  padding: 15px;
}

.small-txt-head {
  color: #72738e;
  font-size: 18px;
  font-weight: 500;
}

.big-txt-head {
  color: #72738e;
  font-size: 21px;
  font-weight: 600;
}

.panlg-card {
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-overflow {
  height: 85%;
  overflow: auto;
}

.w-30 {
  width: 30%;
}

.w-20 {
  width: 20%;
}

.panel-nofeedback-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}
.mobile-feedbk-round-head-jd {
  font-weight: 600;
  font-size: 11px;
  color: #545454;
}
.panlg-input {
  border-radius: 3px;
  border: 0.5px solid #c4c4c4;
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 5px 43px 7px 27px;
}

.panlg-overflow {
  height: 91%;
  overflow: auto;
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.h-95 {
  height: 95%;
}

.panlg-footer {
  height: 9%;
  border-radius: 5px;
  background: #fff;
  border-top: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panlg-blueTxt {
  color: #257cff;
  font-size: 12px;
  font-weight: 400;
}

.panlg-blueBack {
  border-radius: 5px;
  background: rgba(242, 242, 242, 0.98);
  padding: 10px;
}

.panlg-whiteCard {
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.panlg-greytxt {
  color: #6d6d6d;
  font-size: 12px;
  font-weight: 400;
}

.mob-plainbtn {
  color: #72738e;
  font-size: 14px;
  font-weight: 500;
  background-color: transparent;
}

.mob-greybtn {
  border-radius: 3px;
  background: #72738e;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
}
.addpan .btn-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px 5px 10px;
  gap: 10px;

  /* position: absolute;
left: 87.22%;
right: 3.33%;
top: 10.92%;
bottom: 85.22%; */

  background: #20639b;
  border-radius: 40px;
}
.addpan .btn-secondary:hover {
  color: var(--bg-white);
  background-color: #20639b;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.addpan .btn-secondary:not(:disabled):not(.disabled):active,
.addpan .btn-secondary:not(:disabled):not(.disabled).active,
.addpan .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #20639b;
  border-color: #20639b;
}
.addpantxt {
  font-family: "Montserrat", sans-serif, sans-serif;
  font-weight: 600;
  font-size: 13px;
  /* identical to box height */
  display: flex;
  align-items: center;

  color: #ffffff;
}
</style>
